import React, {useState} from 'react';
import { API } from '../../../services';
import { Parser } from '../../index';

const StatusesChange = (props) => {
  const { langs, data } = props;
  const { orderId, statusId, fetchData } = data;

  const api = API()

  const [loading, setLoading] = useState(false);

  const orderStatusChange = async () => {

    setLoading(true)
      await api.updateShopOrderStatus(orderId, statusId);
    setLoading(false)
    props.callback({ type: 'success' });
    props.callback({ type: 'destroy' });
    await fetchData();
  };

  const destroy = (e) => {
    props.callback(e, 'destroy');
    props.callback(e, 'afterDestroy');
  }

  return (
    <div className="custom-modal-wrapper">
      <div className="position-relative">
        <div className="popup-content px-8px content-scroll">
          <h3 className="font-bold-caps font-size-18 pb-32px text-left">
            {langs.NM_Message}
          </h3>
          <Parser html={props.data.customMessage.replace(/<(?!p|br).*?>/g, "")}/>

          <div className="d-flex justify-content-between pt-32px">
            <button
              className="btn bg-blue font-bold-caps font-size-13 text-white px-40px py-16px"
              onClick={() => orderStatusChange()}
              disabled={loading}
            >
              {langs.Confirm}
            </button>
            <button
              className="btn bg-gray font-bold-caps font-size-13 text-white px-40px py-16px"
              onClick={destroy}>
              {langs.Cancel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusesChange;